import { useCallback, useState } from "react";

import { SelectData } from "../../models";
import { GetTaskBoardResponse } from "../../service/query";

interface UseTaskStepOptionsReturnData {
  // The steps of the phase currently in view, for the Step picker.
  stepSelectData: SelectData;
  updateStepsSelectDataByPhase: (phase: string) => void;
  resetStepOptions: () => void;
}

/*
  The Step picker's options. A step belongs to a phase, so the list is whatever the workflow holds for the
  phase in view — a general task has no step at all, and simply never asks.
*/
export const useTaskStepOptions = (
  workflow: GetTaskBoardResponse["results"][number] | undefined
): UseTaskStepOptionsReturnData => {
  const [stepSelectData, setStepSelectData] = useState<SelectData>([]);

  const updateStepsSelectDataByPhase = useCallback(
    (phase: string): void => {
      if (workflow?.steps) {
        setStepSelectData(
          workflow.steps
            .filter((step) => step.phase === phase)
            .map((step) => ({ key: step.uuid, value: step.name })) as SelectData
        );
      }
    },
    [workflow?.steps]
  );

  const resetStepOptions = useCallback((): void => setStepSelectData([]), []);

  return { stepSelectData, updateStepsSelectDataByPhase, resetStepOptions };
};
